
const DEFAULT_ALWAYS_NEST_TYPES = ['FUNCTION', 'JS_FUNCTION',
  'property', 'classmethod', 'staticmethod', 'builtin_function_or_method',
  'member_descriptor', 'getset_descriptor', 'method_descriptor', 'wrapper_descriptor'];


function isCppMode(lang) {
  return (lang === 'c' || lang === 'cpp');
}

export const getTraceLayouts = (curTrace, lang) => {
  let curTraceLayouts = []
  curTraceLayouts.push([])
  curTrace.forEach((curEntry) => {
    let prevLayout = curTraceLayouts[curTraceLayouts.length - 1];
    curTraceLayouts.push(getTraceLayout(curEntry, prevLayout, lang));
  })
  curTraceLayouts.splice(0, 1);
  return curTraceLayouts;
}

export const getTraceLayout = (curEntry, prevLayout, lang) => {


  // make a DEEP COPY of prevLayout to use as the basis for curLine
  var curLayout = JSON.parse(JSON.stringify(prevLayout));

  // initialize with all IDs from curLayout
  var idsToRemove = new Map();
  curLayout.forEach(function(row) {
    for (var j = 1 /* ignore row ID tag */; j < row.length; j++) {
      idsToRemove.set(row[j], 1);
    }
  });


  var idsAlreadyLaidOut = new Map(); // to prevent infinite recursion

  function curLayoutIndexOf(id) {
    for (var i = 0; i < curLayout.length; i++) {
      var row = curLayout[i];
      var index = row.indexOf(id);
      if (index > 0) { // index of 0 is impossible since it's the row ID tag
        return {row: row, index: index}
      }
    }
    return null;
  }

  function isLinearObj(heapObj) {

    return heapObj[0] == 'LIST' || heapObj[0] == 'TUPLE' || heapObj[0] == 'SET';
  }

  function recurseIntoObject(id, curRow, newRow) {
    // heuristic for laying out 1-D linked data structures: check for enclosing elements
    // that are structurallyEquivalent() and then lay them out as siblings in the same "row"
    var heapObj = curEntry.heap[id];

    assert(heapObj);

    if (isLinearObj(heapObj)) {
      heapObj.forEach(function(child, ind) {
        if (ind < 1) return; // skip type tag

        if (!isPrimitiveType(child)) {
          var childID = getRefID(child);
          if (structurallyEquivalent(heapObj, curEntry.heap[childID])) {
            updateCurLayout(childID, curRow, newRow);
          }
          else if (!shouldNestObject(curEntry.heap[childID])) {
            updateCurLayout(childID, [], []);
          }
        }
      });
    }
    else if (heapObj[0] == 'DICT') {
      heapObj.forEach(function(child, ind) {
        if (ind < 1) return; // skip type tag

        var dictKey = child[0];
        if (!isPrimitiveType(dictKey)) {
          var keyChildID = getRefID(dictKey);
          if (!shouldNestObject(curEntry.heap[keyChildID])) {
            updateCurLayout(keyChildID, [], []);
          }
        }

        var dictVal = child[1];
        if (!isPrimitiveType(dictVal)) {
          var childID = getRefID(dictVal);
          if (structurallyEquivalent(heapObj, curEntry.heap[childID])) {
            updateCurLayout(childID, curRow, newRow);
          }
          else if (!shouldNestObject(curEntry.heap[childID])) {
            updateCurLayout(childID, [], []);
          }
        }
      });
    }
    else if (heapObj[0] == 'INSTANCE' || heapObj[0] == 'INSTANCE_PPRINT' || heapObj[0] == 'CLASS') {
      let [className, headerLength] = getClassInstanceMetadata(heapObj);
      heapObj.forEach((child, ind) => {
        if (ind < headerLength) return;

        var instKey = child[0];

        if (!isPrimitiveType(instKey)) {
          var keyChildID = getRefID(instKey);
          if (!shouldNestObject(curEntry.heap[keyChildID])) {
            updateCurLayout(keyChildID, [], []);
          }
        }

        var instVal = child[1];
        if (!isPrimitiveType(instVal)) {
          var childID = getRefID(instVal);
          if (structurallyEquivalent(heapObj, curEntry.heap[childID])) {
            updateCurLayout(childID, curRow, newRow);
          }
          // else if (!shouldNestObject(curEntry.heap[childID])) {
          //   updateCurLayout(childID, [], []);
          // }
        }
      });
    }
    else if (heapObj[0] == 'FUNCTION' || heapObj[0] == 'JS_FUNCTION') {
      // a Python function object has an optional element at index=3
      // (zero-indexed) that represents default arg names/values
      //
      // a JavaScript function object has funcProperties that we should
      // recurse into in order to precompute their layouts
      var funcProperties = null;
      // traverse into default argument values to precompute their
      // layouts, if applicable
      if (heapObj[0] == 'FUNCTION' && heapObj.length > 3) {
        funcProperties = heapObj[3];
      }
      if (heapObj[0] == 'JS_FUNCTION') {
        assert(heapObj.length == 5);
        funcProperties = heapObj[3];
      }

      if (funcProperties) {
        assert(funcProperties.length > 0);
        let funcName = heapObj[1];
        funcProperties.forEach(function(kvPair) {
          // only check this for JS_FUNCTION! we're overloading
          // funcProperties to use for both FUNCTION and
          // JS_FUNCTION, which might be confusing ...
          if (heapObj[0] == 'JS_FUNCTION') {
            let instKey = kvPair[0];

          }

          // copy/paste from INSTANCE/CLASS code above
          var instVal = kvPair[1];
          if (!isPrimitiveType(instVal)) {
            var childID = getRefID(instVal);
            if (!shouldNestObject(curEntry.heap[childID])) {
              updateCurLayout(childID, [], []);
            }
          }
        });
      }
    }
    else if ((heapObj[0] == 'C_ARRAY') || (heapObj[0] == 'C_MULTIDIMENSIONAL_ARRAY') || (heapObj[0] == 'C_STRUCT')) {
      updateCurLayoutAndRecurse(heapObj);
    }
  }


  // a krazy function!
  // id     - the new object ID to be inserted somewhere in curLayout
  //          (if it's not already in there)
  // curRow - a row within curLayout where new linked list
  //          elements can be appended onto (might be null)
  // newRow - a new row that might be spliced into curRow or appended
  //          as a new row in curLayout
  function updateCurLayout(id, curRow, newRow) {
    if (idsAlreadyLaidOut.has(id)) {
      return; // PUNT!
    }

    var curLayoutLoc = curLayoutIndexOf(id);

    var alreadyLaidOut = idsAlreadyLaidOut.has(id);
    idsAlreadyLaidOut.set(id, 1); // unconditionally set now

    // if id is already in curLayout ...
    if (curLayoutLoc) {
      var foundRow = curLayoutLoc.row;
      var foundIndex = curLayoutLoc.index;

      idsToRemove.delete(id); // this id is already accounted for!

      // very subtle ... if id hasn't already been handled in
      // this iteration, then splice newRow into foundRow. otherwise
      // (later) append newRow onto curLayout as a truly new row
      if (!alreadyLaidOut) {
        // splice the contents of newRow right BEFORE foundIndex.
        // (Think about when you're trying to insert in id=3 into ['row1', 2, 1]
        //  to represent a linked list 3->2->1. You want to splice the 3
        //  entry right before the 2 to form ['row1', 3, 2, 1])
        if (newRow.length > 1) {
          var args = [foundIndex, 0];
          for (var i = 1; i < newRow.length; i++) { // ignore row ID tag
            args.push(newRow[i]);
            idsToRemove.delete(newRow[i]);
          }
          foundRow.splice.apply(foundRow, args);

          // remove ALL elements from newRow since they've all been accounted for
          // (but don't reassign it away to an empty list, since the
          // CALLER checks its value. TODO: how to get rid of this gross hack?!?)
          newRow.splice(0, newRow.length);
        }
      }

      // recurse to find more top-level linked entries to append onto foundRow
      recurseIntoObject(id, foundRow, []);
    }
    else {
      // push id into newRow ...
      if (newRow.length == 0) {
        newRow.push('row' + id); // unique row ID (since IDs are unique)
      }
      newRow.push(id);

      // recurse to find more top-level linked entries ...
      recurseIntoObject(id, curRow, newRow);


      // if newRow hasn't been spliced into an existing row yet during
      // a child recursive call ...
      if (newRow.length > 0) {
        if (curRow && curRow.length > 0) {
          // append onto the END of curRow if it exists
          for (var i = 1; i < newRow.length; i++) { // ignore row ID tag
            curRow.push(newRow[i]);
          }
        }
        else {
          // otherwise push to curLayout as a new row
          //
          // TODO: this might not always look the best, since we might
          // sometimes want to splice newRow in the MIDDLE of
          // curLayout. Consider this example:
          //
          // x = [1,2,3]
          // y = [4,5,6]
          // x = [7,8,9]
          //
          // when the third line is executed, the arrows for x and y
          // will be crossed (ugly!) since the new row for the [7,8,9]
          // object is pushed to the end (bottom) of curLayout. The
          // proper behavior is to push it to the beginning of
          // curLayout where the old row for 'x' used to be.
          curLayout.push(JSON.parse(JSON.stringify(newRow)));
        }

        // regardless, newRow is now accounted for, so clear it
        for (var i = 1; i < newRow.length; i++) { // ignore row ID tag
          idsToRemove.delete(newRow[i]);
        }
        newRow.splice(0, newRow.length); // kill it!
      }

    }
  }


  function updateCurLayoutAndRecurse(elt) {
    if (!elt) return; // early bail out

    if (isHeapRef(elt, curEntry.heap)) {
      var id = getRefID(elt);
      updateCurLayout(id, null, []);
    }
    recurseIntoCStructArray(elt);
  }

  // traverse inside of C structs and arrays to find whether they
  // (recursively) contain any references to heap objects within
  // themselves. be able to handle arbitrary nesting!
  function recurseIntoCStructArray(val) {
    if (val[0] === 'C_ARRAY') {
      val.forEach(function(elt, ind) {
        if (ind < 2) return; // these have 2 header fields
        updateCurLayoutAndRecurse(elt);
      });
    } else if (val[0] === 'C_MULTIDIMENSIONAL_ARRAY' || val[0] === 'C_STRUCT') {
      val.forEach(function(kvPair, ind) {
        if (ind < 3) return; // these have 3 header fields

        updateCurLayoutAndRecurse(kvPair[1]);
      });
    }
  }

  // iterate through all globals and ordered stack frames and call updateCurLayout
  curEntry.ordered_globals?.forEach(function(varname, i) {

    var val = curEntry.globals[varname];
    if (val !== undefined) { // might not be defined at this line, which is OKAY!
      // TODO: try to unify this behavior between C/C++ and other languages:
      if (isCppMode(lang)) {
        updateCurLayoutAndRecurse(val);
      } else {
        if (!isPrimitiveType(val)) {
          var id = getRefID(val);
          updateCurLayout(id, null, []);
        }
      }
    }
  });

  curEntry.stack_to_render.forEach(function(frame, i) {
    // some functions are unnamed, so use a placeholder:
    frame.ordered_varnames.forEach(function(varname, xxx) {

      var val = frame.encoded_locals[varname];
      // TODO: try to unify this behavior between C/C++ and other languages:
      if (isCppMode(lang)) {
        updateCurLayoutAndRecurse(val);
      } else {
        if (!isPrimitiveType(val)) {
          var id = getRefID(val);
          updateCurLayout(id, null, []);
        }
      }
    });
  });


  // iterate through remaining elements of idsToRemove and REMOVE them from curLayout
  idsToRemove.forEach(function(value, id) {
    var idInt = Number(id); // keys are stored as strings, so convert!!!
    curLayout.forEach(function(row, rownum) {
      var ind = row.indexOf(idInt);
      if (ind > 0) { // remember that index 0 of the row is the row ID tag
        row.splice(ind, 1);
      }
    });
  });

  // now remove empty rows (i.e., those with only a row ID tag) from curLayout
  curLayout = curLayout.filter(function(row) {return row.length > 1});
  return curLayout
}



export const isPrimitiveType = (obj) => {

  // null is a primitive
  if (obj === null) {
    return true;
  }

  if (typeof obj == "object") {
    // kludgy
    return (obj[0] == 'IMPORTED_FAUX_PRIMITIVE' ||
      obj[0] == 'SPECIAL_FLOAT' || obj[0] == 'JS_SPECIAL_VAL' ||
      obj[0] == 'C_DATA' /* TODO: is this right?!? */);
  }
  else {
    // non-objects are primitives
    return true;
  }
}
const structurallyEquivalent = (obj1, obj2) => {
  // punt if either isn't a compound type
  if (isPrimitiveType(obj1) || isPrimitiveType(obj2)) {
    return false;
  }

  // must be the same compound type
  if (obj1[0] != obj2[0]) {
    return false;
  }

  // must have the same number of elements or fields
  if (obj1.length != obj2.length) {
    return false;
  }

  // for a list or tuple, same size (e.g., a cons cell is a list/tuple of size 2)
  if (obj1[0] == 'LIST' || obj1[0] == 'TUPLE') {
    return true;
  }
  else {
    let i;
    var startingInd = -1;

    if (obj1[0] == 'DICT') {
      startingInd = 1;
    }
    else if (obj1[0] == 'INSTANCE') {
      startingInd = 2;
    }
    else if (obj1[0] == 'INSTANCE_PPRINT') {
      startingInd = 3;
    }
    else {
      return false; // punt on all other types
    }

    var obj1fields = new Map();

    for (i = startingInd; i < obj1.length; i++) {
      obj1fields.set(obj1[i][0], 1); // 用作集合
    }

    for (i = startingInd; i < obj2.length; i++) {
      if (!obj1fields.has(obj2[i][0])) {
        return false;
      }
    }

    return true;
  }
}
const shouldNestObject = (obj) => {
  if (!obj) return false;
  assert(Array.isArray(obj));
  if (DEFAULT_ALWAYS_NEST_TYPES.indexOf(obj[0]) >= 0) {
    // is the type name in alwaysNestTypes?
    return true;
  } else if (obj.length >= 2 &&
    (obj[0] === 'INSTANCE' || obj[0] === 'INSTANCE_PPRINT') &&
    (DEFAULT_ALWAYS_NEST_TYPES.indexOf(obj[1]) >= 0)) {
    // otherwise is this an INSTANCE with the type name (obj[1]) in alwaysNestTypes?
    return true;
  } else {
    return false;
  }
}
function getRefID(obj) {
  if (obj[0] == 'REF') {
    return obj[1];
  } else {
    assert (obj[0] === 'C_DATA' && obj[2] === 'pointer');
    assert (obj[3] != '<UNINITIALIZED>' && obj[3] != '<UNALLOCATED>');
    return obj[3]; // pointed-to address
  }
}
export function assert(condition, message = 'Assertion failed') {
  if (!condition){
    throw new Error(message);
  }
}
export function getClassInstanceMetadata(obj) {
  let typ = obj[0];
  assert(typ == 'INSTANCE' || typ == 'INSTANCE_PPRINT' || typ == 'CLASS');
  let className = obj[1]; // might possibly be ''
  let headerLength = (typ == 'INSTANCE') ? 2 : 3;
  return [className, headerLength];
}
export function generateHeapObjID(id){
  return "v1__heap_object_" + id
}
function isHeapRef(obj, heap) {
  // ordinary REF
  if (obj[0] === 'REF') {
    return (heap[obj[1]] !== undefined);
  } else if (obj[0] === 'C_DATA' && obj[2] === 'pointer') {
    // C-style pointer that has a valid value
    if (obj[3] !== '<UNINITIALIZED>' && obj[3] !== '<UNALLOCATED>') {
      return (heap[obj[3]] !== undefined);
    }
  }

  return false;
}